import React, { useEffect, useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Spinner} from "@nextui-org/react";
import axios from "axios";
import { baseUrlLink, order_uri, orders_uri, product_uri } from "../../../../utils/url";
import { toast } from "react-toastify";
import { PRODUCT_TYPES } from "../../../../utils/types";
import { FaCheck } from "react-icons/fa";
import { MdDeleteOutline } from "react-icons/md";

export default function PayedDetailModal({datas,id, callback}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [pay, setPay] = useState();
  const [load, setLoad] = useState(false);
  const [checkedTracks, setCheckTracks] = useState([]);
  const [data, setData] = useState([]);
  const [checkload, setCheckload] = useState(false);


  useEffect(() => {
    setData(datas)
  }, [])
  
  const call = () =>{
    callback();
  }

  const Sub = async()=>{
    setLoad(true);
    try{
        const res = await axios.post(product_uri+'/olgoh', {ids: checkedTracks, too: data.length});
        if(res.status === 200){
            toast.success("Амжилттай");
            setPay('');
            call();
            onOpenChange(false)
            setLoad(false)
        }
    }catch(err){
        console.log(err);
        setLoad(false);
    }
  }

  const handleDeleteClick = (item) => {
    const track = data.filter(it => it.id === item.id);
    if(track.length > 0){
      setCheckTracks((prevData) => prevData.filter((dataItem) => dataItem.id !== item.id));
    }else{
      setCheckTracks((prevData) => prevData.filter((dataItem) => dataItem.id !== item.id));
      setData((prevCheckedTracks) => [...prevCheckedTracks, item]);
    }
  };

  const handleCheckClick = (item) => {
    const track = checkedTracks.filter(it => it.id === item.id);
    if(track.length > 0){
      setData((prevData) => prevData.filter((dataItem) => dataItem.id !== item.id));
      return toast.warning("Энэ бараа аль хэдийн сонгогдсон байна !");
    }
    setCheckTracks((prevCheckedTracks) => [...prevCheckedTracks, item]);
    setData((prevData) => prevData.filter((dataItem) => dataItem.id !== item.id));
  };
  
  return (
    <>
      <Button size='sm' onClick={onOpen} className="ml-2">Захиалгын дэлгэрэнгүй</Button>
      <Modal size="3xl" isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Захиалгын дэлгэрэнгүй</ModalHeader>
              <ModalBody>
                <table className="min-w-full divide-y divide-gray-200 table-fixed dark:divide-gray-700">
                  <thead className="bg-gray-50 dark:bg-gray-700">
                    <tr>
                      <th scope="col" className="p-4 text-sm font-normal">
                        No
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Бараа
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Өнгө
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                        Хэмжээ
                      </th>
                      <th scope="col" className="py-2 px-6 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                       Тоо
                      </th>
                    </tr>
                  </thead>
                  {
                    load?
                    <div className='flex items-center justify-center  p-4'>
                      <Spinner/>
                      <h1 className=''>Уншиж байна ...</h1>
                    </div>
                    :
                    <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                      {
                        data.map((item, index) => {
                          return(
                            <tr className="hover:bg-gray-100 dark:hover:bg-gray-700" key={index}>
                              <td className="p-2 w-4 text-center">
                                <img className="" src={baseUrlLink+item.product.images[0].url}/>
                              </td>
                              <td className="py-2 px-6 text-sm font-bold text-gray-900 whitespace-nowrap dark:text-white flex flex-col">
                                {item.product.name}
                              </td>
                              <td className="py-2 px-6 text-sm font-bold text-gray-500  dark:text-white text-overflow">
                                {item.color?.name}
                              </td>
                              <td className="py-2 px-6 text-sm font-medium text-gray-500  dark:text-white text-overflow">
                              {item.size?.value}
                              </td>
                              <td className="py-2 flex items-center gap-2 px-6 text-sm font-medium text-gray-500  dark:text-white text-overflow">
                                {item.quantity}
                                {
                                  item.product.product_type == PRODUCT_TYPES.BELEN ?
                                  <div className="bg-green-600 p-1 text-xs text-white rounded-md">Бэлэн</div>
                                  :
                                  <div className="bg-orange-600 p-1 text-xs text-white rounded-md">Захиалгын</div>
                                }
                                <div className='bg-gray-200 p-2 rounded-md hover:bg-gray-300 cursor-pointer' onClick={()=> handleCheckClick(item)}>
                                  <FaCheck size={20}/>
                                </div>
                              </td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  }
                </table>
                <div className='grid col-span-1'>
                  <div>
                    <div className='rounded-md bg-gray-200 text-black mt-2 ml-1 p-4'> 
                        {
                          checkedTracks.map((it, index) => {
                            console.log(it)
                            return(
                              <div key={index} className='flex justify-between items-center ring-2 ring-white bg-green-600 rounded-sm mt-2 p-2'>
                                <div>
                                  <h1>{it.product.name}</h1>
                                  <h1 className='text-gray-200 text-xs'>{it.quantity}</h1>
                                </div>
                                <MdDeleteOutline onClick={()=> handleDeleteClick(it)} className='cursor-pointer' color='red' size={20}/>
                              </div>
                            )
                          })
                        }
                        <div className='p-2 mt-8 text-sm'>
                          {
                            checkload?
                            <Button size='sm' className='w-full'><Spinner/></Button>
                            :
                            <Button size='sm' className='w-full' onClick={Sub}>Олгох</Button>
                          }
                        </div>
                    </div>
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onClick={onClose}>
                  Close
                </Button>
                {/* {
                    load?
                    <Button className="bg-blue-300">
                        Баталгаажуулж байна ...
                    </Button>
                    :
                    <Button color="primary" onClick={Sub}>
                        Төлбөр төлсөн
                    </Button>
                } */}
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
